import { useState, useCallback } from "react";

interface OrderFormPrefill {
  side: "BUY" | "SELL";
  teamCode: string;
  price?: number;
  quantity?: number;
  editingOrderId?: number;
}

export function useOrderForm() {
  const [isOpen, setIsOpen] = useState(false);
  const [prefill, setPrefill] = useState<OrderFormPrefill>({
    side: "BUY",
    teamCode: "",
  });

  const open = useCallback((side: "BUY" | "SELL", teamCode: string, price?: number, quantity?: number, editingOrderId?: number) => {
    setPrefill({ side, teamCode, price, quantity, editingOrderId });
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    prefill,
    open,
    close,
  };
}
